import { Box, Typography } from "@mui/material";
import styles from "./services.module.scss"

const YouthAndEducationActivity = () => {
  return (
    <Box className={styles.ActivityContainer}>
      <Box className={styles.detailConatiner}>
        <Typography className={styles.mainHeading}>Activity</Typography>
        <Typography className={styles.details}>
          Please click on the links below for registering students to attend
          free classes conducted by HCCC Youth & Education Committee or for
          volunteering or just to stay informed about Y&E activities.
        </Typography>
        <Typography className={styles.details}>
          <span><a href="https://docs.google.com/forms/d/e/1FAIpQLScWvupKQeD8AJnWlEGk-sbJMGiGohLWhhy0DpZojgY7APDNpw/viewform" target="_blank">Click here</a></span> to register students to HCCC Y&E Classes
        </Typography>
        <Typography className={styles.details}>
          <span><a href="https://docs.google.com/forms/d/e/1FAIpQLSf090yYe6bRwbxc9vzzX-15uRuwA5FYvzP4QSC58yQz4_LbSQ/viewform" target="_blank">Click here</a></span> to register for volunteering and for teaching
          classes
        </Typography>
        <Typography className={styles.details}>
          <span><a href="https://docs.google.com/forms/d/e/1FAIpQLSeVTWIsaoLX3YmnQfRm9gg51t1qjNmaB5jQoXhX2Dyu5LoCXw/viewform" target="_blank">Click here</a></span> to receive notifications regarding HCCC Y&E
          classes and activities
        </Typography>
      </Box>
      <img src="/images/Youth&EducationActivity.png" className={styles.activityImage} />
    </Box>
  );
};

export default YouthAndEducationActivity;
